import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA4 from 'react-ga4'
import { usePostHog } from 'posthog-js/react'

const PageViewTracker = () => {
  const location = useLocation()
  const posthog = usePostHog()

  useEffect(() => {
    ReactGA4.send('pageview', location.pathname)
    if (posthog) {
      posthog.capture('$pageview', { path: location.pathname })
    }
  }, [location, posthog])

  return null
}

export default PageViewTracker
